var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0996 21.4992L2.39961 1.69922L1.09961 2.99922L2.59961 4.49922C2.29961 4.89922 1.99961 5.39922 1.99961 5.99922V17.9992C1.99961 19.0992 2.89961 19.9992 3.99961 19.9992H18.0996L20.7996 22.6992L22.0996 21.4992ZM3.99961 17.9992V7.99922L9.59961 11.4992L16.0996 17.9992H3.99961ZM9.19961 5.99922L7.19961 3.99922H19.9996C21.0996 3.99922 21.9996 4.89922 21.9996 5.99922V17.9992C21.9996 18.1992 21.9996 18.4992 21.8996 18.6992L19.9996 16.7992V7.99922L14.5996 11.3992L13.3996 10.1992L19.9996 5.99922H9.19961Z",
    fill: "black",
    fillOpacity: 0.38
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEmail);
export default __webpack_public_path__ + "static/media/noEmail.adc9f2e81dde82e7326f604b680b9369.svg";
export { ForwardRef as ReactComponent };